/** Matches the server rate-limit window; only used when a reject omits retryAfterMs. */
const RATE_LIMIT_FALLBACK_MS = 10000;

/** User-facing copy for server moderation error codes. */
export function contentModerationUserMessage(error) {
  if (error === 'ContentModerated') {
    return 'This was blocked by our safety filters.';
  }
  if (error === 'ModerationUnavailable') {
    return 'Could not send right now. Please try again.';
  }
  return null;
}

/** User-facing copy for comment create/update failures. */
export function commentPostUserMessage(error, retryAfterMs) {
  const moderationMessage = contentModerationUserMessage(error);
  if (moderationMessage) return moderationMessage;
  if (error === 'RateLimited') {
    const seconds = Math.max(1, Math.ceil((retryAfterMs || RATE_LIMIT_FALLBACK_MS) / 1000));
    return `Wait ${seconds}s before posting again.`;
  }
  return 'Could not post comment. Please try again.';
}

/** User-facing copy for chat send failures (moderation, rate limit, generic). */
export function chatSendUserMessage(error, retryAfterMs) {
  const moderationMessage = contentModerationUserMessage(error);
  if (moderationMessage) return moderationMessage;
  if (error === 'RateLimited') {
    const seconds = Math.max(1, Math.ceil((retryAfterMs || RATE_LIMIT_FALLBACK_MS) / 1000));
    return `Wait ${seconds}s before sending again.`;
  }
  if (error === 'MessageTooLong') {
    return 'Message is too long.';
  }
  if (error === 'NotLive') {
    return 'Chat is not open yet.';
  }
  if (error) return 'Could not send. Please try again.';
  return null;
}

export function livestreamRateLimitRemainingMs(rateLimitUntilMs) {
  if (!rateLimitUntilMs) return 0;
  return Math.max(0, rateLimitUntilMs - Date.now());
}

export function livestreamRateLimitHint(rateLimitUntilMs) {
  const remainingMs = livestreamRateLimitRemainingMs(rateLimitUntilMs);
  if (!remainingMs) return '';
  const seconds = Math.max(1, Math.ceil(remainingMs / 1000));
  return `Wait ${seconds}s before sending again.`;
}
